<div class="dialog-container" id="submit-modal" role="dialog">
  <img alt="" src="/assets/images/logo.svg" />
  <div class="vtz-modal-content">
    <h1 mat-dialog-title i18n id="title">Exit?</h1>        
    <mat-dialog-content id="description" i18n>Are you sure you wish to exit the app? Exiting will end your current session. You can return before the end of the election window.</mat-dialog-content>
  </div>
  <mat-dialog-actions>
    <div class="dialog-button-container">
      <button i18n class="button-secondary button-narrow-screen" cdkFocusInitial mat-dialog-close>BACK</button>
      <div class="vtz-spacer-10"></div>
      <button id="exit-button" i18n class="button-primary button-narrow-screen" (click)="exit()">CONFIRM</button>
    </div>
  </mat-dialog-actions>
</div>
